<template>
	<div class="home">
		<van-nav-bar
			left-arrow
			fixed
			:title="$t('printerSet.title')"
		  	@click-left="$router.go(-1)">
		  	<van-icon name="./static/img/ok.png" slot="right" @click="addPrinter()" style="font-size: 24px;"/>
		</van-nav-bar>
		<template v-if="isKitchen">
			<van-cell-group :title="kitchenPrinter[0].mark">
				<div class="delBtn" @click="delPrinter(kitchenPrinter[0].id)">删除</div>
				<van-field
				    v-model="kitchenPrinterText[0]"
				   	:label="$t('printerSet.printerBrand')"
					:placeholder="$t('printerSet.printerBrand')"
					readonly
					right-icon="arrow"
					@click="showSelect0"
				/>
				<div v-if="showKitchen[0]">
					<van-popup v-model="showCategory" position="bottom" :style="{ height: '50%' }" >
						<van-picker
							show-toolbar
							:columns="brandName"
							@cancel="showCategory = false"
							@confirm="editCategory0"
							:confirm-button-text="$t('vantText.confirm')"
							:cancel-button-text="$t('vantText.cancel')"
			  			/>
					</van-popup>
				</div>
				<van-field
				    v-model="kitchenPrinter[0].sn"
				   	:label="$t('printerSet.printerSN')"
					:placeholder="$t('printerSet.printerSN')"
					clearable
				/>
				<van-field
					v-if="kitchenPrinter[0].category==2"
				    v-model="kitchenPrinter[0].key"
				   	:label="$t('printerSet.printerKey')"
					:placeholder="$t('printerSet.printerKey')"
					clearable
				/>
			</van-cell-group>

			<van-cell-group :title="kitchenPrinter[1].mark">
				<div class="delBtn" @click="delPrinter(kitchenPrinter[1].id)">删除</div>
				<van-field
				    v-model="kitchenPrinterText[1]"
				   	:label="$t('printerSet.printerBrand')"
					:placeholder="$t('printerSet.printerBrand')"
					readonly
					right-icon="arrow"
					@click="showSelect1"
				/>
				<div v-if="showKitchen[1]">
					<van-popup v-model="showCategory" position="bottom" :style="{ height: '50%' }" >
						<van-picker
							show-toolbar
							:columns="brandName"
							@cancel="showCategory = false"
							@confirm="editCategory1"
							:confirm-button-text="$t('vantText.confirm')"
							:cancel-button-text="$t('vantText.cancel')"
			  			/>
					</van-popup>
				</div>	
				<van-field
				    v-model="kitchenPrinter[1].sn"
				   	:label="$t('printerSet.printerSN')"
					:placeholder="$t('printerSet.printerSN')"
					clearable
				/>
				<van-field
					v-if="kitchenPrinter[1].category==2"
				    v-model="kitchenPrinter[1].key"
				   	:label="$t('printerSet.printerKey')"
					:placeholder="$t('printerSet.printerKey')"
					clearable
				/>
			</van-cell-group>

			<van-cell-group :title="kitchenPrinter[2].mark">
				<div class="delBtn" @click="delPrinter(kitchenPrinter[2].id)">删除</div>
				<van-field
				    v-model="kitchenPrinterText[2]"
				   	:label="$t('printerSet.printerBrand')"
					:placeholder="$t('printerSet.printerBrand')"
					readonly
					right-icon="arrow"
					@click="showSelect2"
				/>
				<div v-if="showKitchen[2]">
					<van-popup v-model="showCategory" position="bottom" :style="{ height: '50%' }" >
						<van-picker
							show-toolbar
							:columns="brandName"
							@cancel="showCategory = false"
							@confirm="editCategory2"
							:confirm-button-text="$t('vantText.confirm')"
							:cancel-button-text="$t('vantText.cancel')"
			  			/>
					</van-popup>
				</div>	
				<van-field
				    v-model="kitchenPrinter[2].sn"
				   	:label="$t('printerSet.printerSN')"
					:placeholder="$t('printerSet.printerSN')"
					clearable
				/>
				<van-field
					v-if="kitchenPrinter[2].category==2"
				    v-model="kitchenPrinter[2].key"
				   	:label="$t('printerSet.printerKey')"
					:placeholder="$t('printerSet.printerKey')"
					clearable
				/>
			</van-cell-group>

			<van-cell-group :title="kitchenPrinter[3].mark">
				<div class="delBtn" @click="delPrinter(kitchenPrinter[3].id)">删除</div>
				<van-field
				    v-model="kitchenPrinterText[3]"
				   	:label="$t('printerSet.printerBrand')"
					:placeholder="$t('printerSet.printerBrand')"
					readonly
					right-icon="arrow"
					@click="showSelect3"
				/>
				<div v-if="showKitchen[3]">
					<van-popup v-model="showCategory" position="bottom" :style="{ height: '50%' }" >
						<van-picker
							show-toolbar
							:columns="brandName"
							@cancel="showCategory = false"
							@confirm="editCategory3"
							:confirm-button-text="$t('vantText.confirm')"
							:cancel-button-text="$t('vantText.cancel')"
			  			/>
					</van-popup>
				</div>	
				<van-field
				    v-model="kitchenPrinter[3].sn"
				   	:label="$t('printerSet.printerSN')"
					:placeholder="$t('printerSet.printerSN')"
					clearable
				/>
				<van-field
					v-if="kitchenPrinter[3].category==2"
				    v-model="kitchenPrinter[3].key"
				   	:label="$t('printerSet.printerKey')"
					:placeholder="$t('printerSet.printerKey')"
					clearable
				/>
			</van-cell-group>

			<van-cell-group :title="kitchenPrinter[4].mark">
				<div class="delBtn" @click="delPrinter(kitchenPrinter[4].id)">删除</div>
				<van-field
				    v-model="kitchenPrinterText[4]"
				   	:label="$t('printerSet.printerBrand')"
					:placeholder="$t('printerSet.printerBrand')"
					readonly
					right-icon="arrow"
					@click="showSelect4"
				/>
				<div v-if="showKitchen[4]">
					<van-popup v-model="showCategory" position="bottom" :style="{ height: '50%' }" >
						<van-picker
							show-toolbar
							:columns="brandName"
							@cancel="showCategory = false"
							@confirm="editCategory4"
							:confirm-button-text="$t('vantText.confirm')"
							:cancel-button-text="$t('vantText.cancel')"
			  			/>
					</van-popup>
				</div>	
				<van-field
				    v-model="kitchenPrinter[4].sn"
				   	:label="$t('printerSet.printerSN')"
					:placeholder="$t('printerSet.printerSN')"
					clearable
				/>
				<van-field
					v-if="kitchenPrinter[4].category==2"
				    v-model="kitchenPrinter[4].key"
				   	:label="$t('printerSet.printerKey')"
					:placeholder="$t('printerSet.printerKey')"
					clearable
				/>
			</van-cell-group>
		</template>
		<template v-else>
			<van-cell-group>
				<van-field
				    v-model="printerText"
				   	:label="$t('printerSet.printerBrand')"
					:placeholder="$t('printerSet.printerBrand')"
					readonly
					right-icon="arrow"
					@click="showCategory=true"
				/>
				<van-popup v-model="showCategory" position="bottom" :style="{ height: '50%' }" >
					<van-picker
					    show-toolbar
					    :columns="brandName"
					    @cancel="showCategory = false"
					    @confirm='onConfirmCategory'
					    :confirm-button-text="$t('vantText.confirm')"
					    :cancel-button-text="$t('vantText.cancel')"
		  			/>
				</van-popup>
				<van-field
				    v-model="printer.sn"
				   	:label="$t('printerSet.printerSN')"
					:placeholder="$t('printerSet.printerSN')"
					clearable
				/>
				<van-field
					v-if="printer.category==2"
				    v-model="printer.key"
				   	:label="$t('printerSet.printerKey')"
					:placeholder="$t('printerSet.printerKey')"
					clearable
				/>
			</van-cell-group>
			<div class="delBtn1">
				<van-button type="danger" @click="delPrinter(printer.id)">删除</van-button>
			</div>
		</template>
	</div>
</template>
<script>
export default {
    data () {
      	return {
      		printer:{},
			kitchenPrinter:[
				{
					id: '',
					store_id:sessionStorage.actShopId,
					sn:'',
					key:'',
					type:0,
					category:'',
					mark:'A'
				},
				{
					id: '',
					store_id:sessionStorage.actShopId,
					sn:'',
					key:'',
					type:0,
					category:'',
					mark:'B'
				},
				{
					id: '',
					store_id:sessionStorage.actShopId,
					sn:'',
					key:'',
					type:0,
					category:'',
					mark:'C'
				},
				{
					id: '',
					store_id:sessionStorage.actShopId,
					sn:'',
					key:'',
					type:0,
					category:'',
					mark:'D'
				},
				{
					id: '',
					store_id:sessionStorage.actShopId,
					sn:'',
					key:'',
					type:0,
					category:'',
					mark:'E'
				}
			],
      		isKitchen:sessionStorage.type==0?true:false,
      		printerText:'',
      		kitchenPrinterText:['','','','',''],
      		showCategory:false,
      		brandName:[],
      		brands:[],
      		showKitchen:[false,false,false,false,false],
      	}
    },
    mounted:function(){
    	this.getCategoryList();
    	// console.log(sessionStorage.printerData);
    	if(sessionStorage.type==0){
    		let printerData = JSON.parse(sessionStorage.printerData);
    		this.isKitchen = true;
    		let kitchenList = [];
    		for (let i=0; i<5;i++) {
    			let data = {};
    			if(i<printerData.length){
	    			data = {
	    				id: printerData[i].id,
	    				store_id:sessionStorage.actShopId,
						sn:printerData[i].sn?printerData[i].sn:'',
						key:printerData[i].key?printerData[i].key:'',
						type:printerData[i].type,
						category:printerData[i].category?printerData[i].category:'',
						mark:printerData[i].mark?printerData[i].mark:'',
	    			};
    			}else{
    				let mark;
    				if(i==0){
    					mark = 'A';
					}else if(i==1){
						mark = 'B';
					}else if(i==2){
						mark = 'C';
					}else if(i==3){
						mark = 'D';
					}else if(i==4){
						mark = 'E';
    				}
    				data = {
    					id: '',
	    				store_id:sessionStorage.actShopId,
						sn:'',
						key:'',
						type:0,
						category:'',
						mark:mark,
	    			};
    			}
    			kitchenList.push(data);
    		}
    		this.kitchenPrinter = kitchenList;
    	}else{
    		let printerData = JSON.parse(sessionStorage.printerData);
    		console.log(printerData.type);
			this.printer = {
				id: printerData.id,
				store_id:sessionStorage.actShopId,
				sn:printerData.sn?printerData.sn:'',
				key:printerData.key?printerData.key:'',
				type:printerData.type,
				category:printerData.category?printerData.category:'',
				// mark:sessionStorage.printerData.mark
			}    		
    	}
    },
    methods:{
    	onConfirmCategory(value,index){
			this.showCategory = false;
			this.printer.category = this.brands[index].id;
			this.printerText = value;
    	},
    	showSelect0(){
    		this.showKitchen = [true,false,false,false,false];
    		this.showCategory = true;
    	},
    	showSelect1(){
    		this.showKitchen = [false,true,false,false,false];
    		this.showCategory = true;
    	},
    	showSelect2(){
    		this.showKitchen = [false,false,true,false,false];
    		this.showCategory = true;
    	},
    	showSelect3(){
    		this.showKitchen = [false,false,false,true,false];
    		this.showCategory = true;
    	},
    	showSelect4(){
    		this.showKitchen = [false,false,false,false,true];
    		this.showCategory = true;
    	},
    	editCategory0(value,index){
    		this.showCategory = false;
    		this.kitchenPrinter[0].category = this.brands[index].id;
			this.kitchenPrinterText[0] = value;
    	},
    	editCategory1(value,index){
    		this.showCategory = false;
    		this.kitchenPrinter[1].category = this.brands[index].id;
			this.kitchenPrinterText[1] = value;
    	},
    	editCategory2(value,index){
    		this.showCategory = false;
    		this.kitchenPrinter[2].category = this.brands[index].id;
			this.kitchenPrinterText[2] = value;
    	},
    	editCategory3(value,index){
    		this.showCategory = false;
    		this.kitchenPrinter[3].category = this.brands[index].id;
			this.kitchenPrinterText[3] = value;
    	},
    	editCategory4(value,index){
    		this.showCategory = false;
    		this.kitchenPrinter[4].category = this.brands[index].id;
			this.kitchenPrinterText[4] = value;
    	},
		getCategoryList(){
			this.$axios({
				method: 'get',
				headers: {
					"Authorization": 'Bearer '+sessionStorage.token,
				},
				url: this.$build+'/api/printermodel/index',
			}).then(res => {
				console.log(res);
				if(res.data.status==200){
					this.brands=res.data.data;
					for(var i =0 ; i<this.brands.length ; i++){
						this.brandName.push(this.brands[i].name_cn+'('+this.brands[i].name_en+')');			
						if(this.brands[i].id==this.printer.category){
							this.printerText=this.brands[i].name_cn+'('+this.brands[i].name_en+')';
						}
						for (var j =0 ; j<this.kitchenPrinter.length ; j++) {
							if(this.brands[i].id==this.kitchenPrinter[j].category){
								this.$set(this.kitchenPrinterText,j,this.brands[i].name_cn+'('+this.brands[i].name_en+')');
							}
						}
					}
				}else{
				}
			}).catch(err => {
				this.$toast({
					type:'fail',
					message:this.$t('EditShop.message'),
				});
			});
		},
		addPrinter(){
			if(sessionStorage.type==0){
				this.kitchenPrinter.forEach((item,index) => {
					if(index==0){
						if(!item.category){
							this.$toast({
								type:'fail',
								message:this.$t('printerSet.printerBrand'),
							});
						}else if(!item.sn){
							this.$toast({
								type:'fail',
								message:this.$t('printerSet.printerSN'),
							});
						}else if(item.category==2&&!item.key){
							this.$toast({
								type:'fail',
								message:this.$t('printerSet.printerKey'),
							});
						}else{
							this.savePrinter(item);
						}
					}else{
						if(!item.category||!item.sn||(item.category==2&&!item.key)){
						}else{
							this.savePrinter(item);
						}
					}
                })
			}else{
				// console.log(this.printer);
				if(!this.printer.category){
					this.$toast({
						type:'fail',
						message:this.$t('printerSet.printerBrand'),
					});
				}else if(!this.printer.sn){
					this.$toast({
						type:'fail',
						message:this.$t('printerSet.printerSN'),
					});
				}else if(this.printer.category==2&&!this.printer.key){
					this.$toast({
						type:'fail',
						message:this.$t('printerSet.printerKey'),
					});
				}else{
					this.savePrinter(this.printer);
				}
			}
		},
		savePrinter(data){
			this.$axios({
				method: 'POST',
				headers: {
					"Authorization": 'Bearer '+sessionStorage.token,
				},
				url: this.$build+'/api/storeprinter/addPrinters',
				data:data,
			}).then(res => {
				// console.log(res);
				if(res.data.status==200){
					this.$toast({
                        type:'success',
                        message:res.data.message,
                    });
					const vm=this;
                    setTimeout(function(){
                        vm.$router.push('/PrinterList');
                    },1000);
				}else{
					this.$toast.allowMultiple();
					for (var item in res.data.error) {
                        this.$toast({
                            type:'fail',
                            message:res.data.error[item],
                        });
                    }
				}
			}).catch(err => {
				this.$toast({
					type:'fail',
					message:this.$t('EditShop.message'),
				});
			});
		},
		delPrinter(id){
			if(!!id){
				this.$dialog.confirm({
	                title: this.$t('printerSet.del'),
	                message: this.$t('printerSet.isDelPrint'),
	                confirmButtonColor:'#FFC914',
	                confirmButtonText:this.$t('vantText.confirm'),
					cancelButtonText:this.$t('vantText.cancel'),
	            }).then(() => {
	                this.$axios({
	                    method: 'DELETE',
	                    headers: {
	                        "Authorization": 'Bearer '+sessionStorage.token,
	                    },
	                    url: this.$build+'/api/storeprinter/'+id+'/destroy',
	                }).then(res => {
	                    console.log(res);
	                    if(res.data.status==200){
	                        this.$toast({
	                            type:'success',
	                            message:res.data.message,
	                        });
	                        const vm=this;
	                        setTimeout(function(){
	                            vm.$router.push('/PrinterList');
	                        },1000);
	                    }else{
	                        for (var item in res.data.error) {
	                            this.$toast({
	                                type:'fail',
	                                message:res.data.error[item],
	                            });
	                        }
	                    }
	                }).catch(err => {
	                    this.$toast({
	                        type:'fail',
	                        message:this.$t('EditShop.message'),
	                    });
	                });
	            }).catch(() => {
	                
	            });
			}else{
				this.$toast({
                    type:'fail',
                    message:this.$t('NoData.noData'),
                });
			}
		}
    },
}
</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	/deep/ .van-field__left-icon .van-icon{
		font-size: 20px;
	}
	/deep/ .van-cell .van-icon{
		font-size: 20px;
	}
	/deep/ .van-field__control{
		text-align: right;
	}
	.delBtn{width: auto;padding: 4px 10px;color: #fff;font-size: 14px;line-height: 16px;position: absolute;top: -32px;right: 16px;background-color: #ee0a24;border-radius: 5px;}
	.delBtn1{text-align: center;margin: 25px 0;}
	/deep/ .van-button--normal{border-radius: 5px;}
	.home{
		width: 100%;
		/*height: 100vh;*/
		background: #F3F5F7;
		padding-bottom: 60px;
	}
	/deep/ .van-picker__cancel,/deep/ .van-picker__confirm{
		color:#2f75f4;
	}
	/deep/ .van-cell-group{
		background: #f3f5f7;
	}
	/deep/ .van-field__control{
		text-align: left;
	}
</style>




// WEBPACK FOOTER //
// src/Shop/PrinterSet.vue